module.exports = __webpack_public_path__ + "static/media/illustration-referee.fa0200ed.png";